import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import FormElement from '@wix/da-ds/pkg/formControls/layouts/FormElement';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import BooleanInput from '@wix/da-ds/pkg/formControls/dsPresets/BooleanInput';
import { OriginalDeviationFieldName } from '../../types';

import s from './FlagsField.scss';

interface Props {}

const FlagsField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control } = useFormContext();

  const { field: matureContent } = useController({
    name: OriginalDeviationFieldName.MATURE_CONTENT,
    control,
  });
  const { field: noAi } = useController({
    name: OriginalDeviationFieldName.NO_AI,
    control,
  });
  const { field: isAiGenerated } = useController({
    name: OriginalDeviationFieldName.IS_AI_GENERATED,
    control,
  });

  return (
    <FormElement
      inputId={id}
      label={
        <InputLabelText>
          {t('originalDeviationPopup.form.flags.label')}
        </InputLabelText>
      }
      noBottomSpacing
    >
      <div className={s['flags-wrapper']}>
        <BooleanInput
          id={id}
          name={matureContent.name}
          value={matureContent.value}
          onChange={matureContent.onChange}
          type="checkbox"
          size="small"
          label={t('originalDeviationPopup.form.matureContent.label')}
          noBottomSpacing
        />
        <BooleanInput
          id={id}
          name={noAi.name}
          value={noAi.value}
          onChange={noAi.onChange}
          type="checkbox"
          size="small"
          label={t('originalDeviationPopup.form.noAi.label')}
          noBottomSpacing
        />
        <BooleanInput
          id={id}
          name={isAiGenerated.name}
          value={isAiGenerated.value}
          onChange={isAiGenerated.onChange}
          type="checkbox"
          size="small"
          label={t('originalDeviationPopup.form.isAiGenerated.label')}
          noBottomSpacing
        />
      </div>
    </FormElement>
  );
};
FlagsField.displayName = 'FlagsField';

export default FlagsField;
